import { Button, Input, InputNumber, Modal, Typography } from 'antd'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

import { useNotification } from '@/Ship/Hooks/useNotification'

import { CreateTypicalRouteModalStore } from '../../Stores/CreateTypicalRouteModalStore'

const { Text } = Typography

interface CreateTypicalRouteModalProps {
    open: boolean
    loadingPointIri: string | null
    unloadingPointIri: string | null
    loadingPointTitle?: string
    unloadingPointTitle?: string
    onClose: () => void
    // eslint-disable-next-line no-unused-vars -- false positive: ESLint core rule flags param names in function-type signatures
    onCreated: (route: any) => void
}

/**
 * Inline "create a new typical route" modal, opened from the typicalRoute
 * dropdown's "+ Створити новий маршрут" option. loadingPoint/unloadingPoint are
 * pinned to the assignment card's current points (not editable here) — the
 * dropdown is already scoped to that pair, so the new route must match it.
 */
export const CreateTypicalRouteModal = observer(
    ({
        open,
        loadingPointIri,
        unloadingPointIri,
        loadingPointTitle,
        unloadingPointTitle,
        onClose,
        onCreated,
    }: CreateTypicalRouteModalProps) => {
        const [store] = useState(() => new CreateTypicalRouteModalStore())
        const { showSuccess, showError } = useNotification()

        const handleCreate = async () => {
            if (!loadingPointIri || !unloadingPointIri) return
            const route = await store.create(loadingPointIri, unloadingPointIri, {
                success: showSuccess,
                error: showError,
            })
            if (route) {
                onCreated(route)
                onClose()
            }
        }

        return (
            <Modal
                open={open}
                title="Створити типовий маршрут"
                onCancel={onClose}
                footer={[
                    <Button key="cancel" onClick={onClose}>
                        Скасувати
                    </Button>,
                    <Button key="create" type="primary" loading={store.loading} onClick={handleCreate}>
                        Створити
                    </Button>,
                ]}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    <Text type="secondary">
                        {loadingPointTitle || '—'} → {unloadingPointTitle || '—'}
                    </Text>
                    <Input
                        placeholder="Назва маршруту *"
                        value={store.title}
                        onChange={(e) => store.setTitle(e.target.value)}
                        autoFocus
                    />
                    <Input
                        placeholder="Посилання на карту, напр. https://maps.app.goo.gl/..."
                        value={store.routeUrl}
                        onChange={(e) => store.setRouteUrl(e.target.value)}
                    />
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Text style={{ minWidth: 80 }}>Пріоритет:</Text>
                        <InputNumber
                            value={store.priority}
                            onChange={(v) => store.setPriority(v ?? 0)}
                            style={{ width: '100%' }}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
)
